import React from 'react';
const { useState, useEffect } = React;
import { cardSt, mutedSt, labelSt } from '../diagnostic/shared.jsx';
import { ownerCall } from './shared.jsx';

// Hoy · Ingresos as one compact line under «Pendientes»: per currency, this month's net collected, the pending
// balance and the overdue balance (always the three, never only the overdue instalments), plus a short warning for
// unapplied money or amounts to resolve and the income goals Ale highlights. The same calculations and the same
// owner-only read view as Ingresos (owner-space › financeToday); nothing is written and there is no other source.
// Every figure opens Ingresos, where the detail and the explanations stay. A failure is said, with «Reintentar».
// Payments are registered by hand; online payment through a gateway is still pending.
const fmt = (n, cur) => { try { return new Intl.NumberFormat('es', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(n); } catch { return `${cur} ${n}`; } };
const linkBtn = { background: 'none', border: 'none', padding: 0, color: 'var(--globant-green)', cursor: 'pointer', fontSize: 12, textAlign: 'left' };
const figBtn = { ...linkBtn, color: 'var(--globant-text)', fontSize: 13 };

export default function TodayMoney({ today, onOpenFinance }) {
  const [m, setM] = useState(null);
  const [error, setError] = useState('');
  const load = () => { setError(''); ownerCall({ action: 'financeToday', today }).then(setM).catch(e => setError(e.message || 'No se pudo cargar Ingresos.')); };
  useEffect(() => { setM(null); load(); }, [today]);
  const box = { ...cardSt, padding: '8px 12px' };
  if (error) return (
    <section aria-label="Ingresos" style={box}>
      <div role="alert" style={{ fontSize: 12, color: '#9A6212', display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
        <span>No se pudo cargar Ingresos: {error} Los importes no se muestran como cero.</span>
        <button type="button" className="action-btn" style={{ fontSize: 11, padding: '2px 8px' }} onClick={load}>Reintentar</button>
        <button type="button" style={linkBtn} onClick={onOpenFinance}>Abrir Ingresos</button>
      </div>
    </section>
  );
  if (!m) return <section aria-label="Ingresos" style={box}><span style={mutedSt}>Ingresos · cargando…</span></section>;
  const currencies = Object.entries(m.byCurrency);
  const w = m.warnings;
  const warn = [
    ...w.unapplied.map(u => `${fmt(u.amount, u.currency)} sin aplicar`),
    w.toResolve ? `${w.toResolve} plan${w.toResolve === 1 ? '' : 'es'} por resolver` : '',
    w.legacyWithoutAmount ? `${w.legacyWithoutAmount} registro${w.legacyWithoutAmount === 1 ? '' : 's'} sin importe` : '',
  ].filter(Boolean);
  return (
    <section aria-label="Ingresos" style={box}>
      <div style={{ display: 'flex', gap: '2px 14px', flexWrap: 'wrap', alignItems: 'baseline' }}>
        <span style={{ ...labelSt, margin: 0 }}>Ingresos</span>
        {!currencies.length && <span style={mutedSt}>Sin cobros ni saldos este mes.</span>}
        {currencies.map(([cur, b]) => (
          <span key={cur} style={{ display: 'inline-flex', gap: '2px 10px', flexWrap: 'wrap', alignItems: 'baseline' }}>
            {currencies.length > 1 && <span style={mutedSt}>{cur}</span>}
            <button type="button" style={figBtn} onClick={onOpenFinance}>Cobrado del mes <b>{fmt(b.net, cur)}</b></button>
            <button type="button" style={figBtn} onClick={onOpenFinance}>Pendiente {fmt(b.pending, cur)}</button>
            <button type="button" style={{ ...figBtn, color: b.overdue > 0 ? '#B4362C' : 'var(--globant-text)' }} onClick={onOpenFinance}>Vencido {fmt(b.overdue, cur)}{b.overdue > 0 ? ` (${b.overdueCount})` : ''}</button>
          </span>
        ))}
        <button type="button" style={{ ...linkBtn, marginLeft: 'auto' }} onClick={onOpenFinance}>Ver detalle</button>
      </div>
      {warn.length > 0 && <button type="button" style={{ ...linkBtn, color: '#9A6212', display: 'block', marginTop: 2 }} onClick={onOpenFinance}>Revisar: {warn.join(' · ')}</button>}
      {m.goals.map(g => (
        <button key={g.id} type="button" style={{ ...linkBtn, display: 'block', color: 'var(--globant-text)', marginTop: 2 }} onClick={onOpenFinance}>
          🎯 {g.title}: {fmt(g.progress.value, g.progress.currency)} de {fmt(g.progress.target, g.progress.currency)}{g.progress.reached ? ' · meta alcanzada' : ''}
        </button>
      ))}
    </section>
  );
}
